import { type IFile } from "src/interfaces";

import { useTheme } from "../../../../../hooks";
import AttachmentsRow from "./AttachmentsRow";

interface Props {
  files: IFile[];
}

const Attachments = ({ files }: Props) => {
  const theme = useTheme() as any;
  return (
    <div
      style={{
        padding: "10px",
        gap: "15px",
        border: `1px solid ${theme.colors.grayText}`,
        margin: "18px",
      }}>
      <p style={{ fontSize: "20px", fontWeight: 600 }}>Attachments</p>
      <div
        style={{
          marginLeft: "18px",
          display: "flex",
          flexWrap: "wrap",
          gap: "8px",
        }}>
        {files.map((file, index) => (
          <AttachmentsRow key={`file-${index}`} row={file} />
        ))}
      </div>
    </div>
  );
};
export default Attachments;
